(function($, velir, google) {
  var ns = nspace("ccc.viz.map.layers");

  /**
   * @class ChoroplethOverlay
   * The thematic choropleth data overlay
   */
	ns.ChoroplethMapType = function (projection, filterString, overlays) {
    // "private" members
    this._projection = projection;
    this._filterString = filterString;
    this._pendingTileUrls = [];
		this._overlays = overlays;
  };

  /**
   * @class ChoroplethOverlay prototype
   * The thematic choropleth data overlay
   */
  (function(proto) {
    proto.tileSize = new google.maps.Size(256, 256);
    proto.maxZoom = 19;

    /**
     * Generate a DOM node representing a tile
     */
    proto.getTile = function(coord, zoom, ownerDocument) {
      // These are the same styles set by the "out of the box" ImageMapType layer
      var $container = $("<div/>")
        .css("-webkit-user-select", "none")
        .css("border-top-width", "0px")
        .css("border-right-width", "0px")
        .css("border-bottom-width", "0px")
        .css("border-left-width", "0px")
        .css("border-style", "initial")
        .css("border-color", "initial")
        .css("padding-top", "0px")
        .css("padding-right", "0px")
        .css("padding-bottom", "0px")
        .css("padding-left", "0px")
        .css("margin-top", "0px")
        .css("margin-right", "0px")
        .css("margin-bottom", "0px")
        .css("margin-left", "0px")
        .css("width", "256px")
        .css("height", "256px")
        .css("display", "inline");

      // The tile image
      var $img = $("<img/>");

      // Listen for the image to finish loading
      var overlay = this;
      $img.bind("load error abort", function(e) {
        // Remove the image from our list of pending urls
        overlay.removePending($img[0]);

        // If the pending url list is empty emit an event to indicate that the tiles are finished loading
        if (overlay._pendingTileUrls.length === 0) {
          $(overlay).trigger("idle");
        }

        if (e.type !== "load") {
          return;
        }

        // make the tile fade-in
        $(this).fadeIn(600);
      });

      $img
        .hide()
        .attr("src", this.getTileUrl(coord, zoom))
        .appendTo($container);

      return $container[0];
    };

    /**
     * Removes a URL from the list of pending URLs
     */
    proto.removePending = function(imgElement) {
      var index = $.inArray(imgElement.src, this._pendingTileUrls);
      if (index > -1) {
        this._pendingTileUrls.splice(index, 1);
      }
    };

    /**
     * Cleans up the node before for removal from the DOM
     */
    proto.releaseTile = function(node) {
      var self = this;
      $("img", node).each(function() {
        // clean up any event handlers (cause IE sucks)
        $(this).unbind();

        // remove this url from the list of pending urls, if necessary
        self.removePending(this);
      });
    };

    /**
     * Generates the URL from which to retrieve a tile
     */
    proto.getTileUrl = function(coord, zoom) {
      // assume square tiles
      var size = this.tileSize.width;

      // Figure out the lat/long for the current tile
      var zfactor = Math.pow(2, zoom);
      var top = this._projection.fromPointToLatLng(
        new google.maps.Point(
          (coord.x * size) / zfactor,
          (coord.y * size) / zfactor
        )
      );
      var bot = this._projection.fromPointToLatLng(
        new google.maps.Point(
          ((coord.x + 1) * size) / zfactor,
          ((coord.y + 1) * size) / zfactor
        )
      );

      // bounding box
      var bbox =
        top.lng() + ", " + bot.lat() + ", " + bot.lng() + ", " + top.lat();

      // build our query string
      var qs = new velir.collections.NameValueCollection();
      qs.add("request", "GetMap"); //WMS operation
      qs.add("service", "WMS"); //WMS service
			qs.add("version", "1.3.0"); //WMS version
      qs.add("format", "image/png"); //WMS format
      qs.add("transparent", "true");
      qs.add("styles", "default"); // value is options, param is required
      qs.add("crs", "EPSG:4326"); //set WGS84
      qs.add("bbox", bbox); // set bounding box

      qs.add("width", "" + size); //tile size
      qs.add("height", "" + size);

      // uncomment the next line to always force tile regeneration
      //qs.add("force", true);

      var parms = ccc.viz.util.UrlParams;
      var config = ccc.viz.map.config.MapConfig;

      // filter string
      qs.add(parms.filterString, this._filterString);

      // theme colors
      qs.add(parms.themeColors, config.getThemeColorString());

      // assemble the URL
			var layersParam = "&layers=default" + (this._overlays ? ',' + this._overlays : ''); // WMS layers; add separately so they're not escaped
			var formatOptions = "&format_options=antialiasing:on;dpi:1000;"; // add separately so it's not encoded
			var url = config.serviceUrl + "?" + qs.toQueryString() + layersParam + formatOptions;
      if (!_.str.startsWith(url.toLowerCase(), "http")) {
        // Prefix with current protocol/port/host
        url = _.str.sprintf("%(protocol)s//%(host)s%(port)s%(slash)s%(path)s", {
          protocol: window.location.protocol,
          host: window.location.host,
          port: _.str.isBlank(window.location.port)
            ? ""
            : ":" + window.location.port,
          slash: _.str.startsWith(url, "/") ? "" : "/",
          path: url
        });
      }

      // Add this to the list of tiles that have not yet finished loading
      this._pendingTileUrls.push(url);

      // If this is our first pending tile, signal that we just became busy
      if (this._pendingTileUrls.length === 1) {
        $(this).trigger("busy");
      }

      return url; // return URL for the tile
    };
  })(ns.ChoroplethMapType.prototype);
})(jQuery, velir, google);
